// extracted by mini-css-extract-plugin
export default {"chat-section-main":"ChatSection_chat-section-main__yQey9","warning-text":"ChatSection_warning-text__JzzwS"};